import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, PropsWithChildren } from 'react'

import { CheckDecagramOutline } from '@Assets/SVG'
import CashMultiple from '@Assets/SVG/CashMultiple'
import SvgTruck2 from '@Assets/SVG/Truck2'
import { useTranslation } from '@Globals/Translations'

import styles from './ClubInfo.module.scss'

export interface ClubInfoProps {
  className?: string
  itemClassName?: string
}

const ClubInformations = [
  {
    title: 'common:TRENDHIMCLUB_15_PERCENTAGE_CASHBACK',
    text: 'common:TRENDHIMCLUB_EVERY_ORDER_AVAILABLE_INSTANTLY',
    icon: <CashMultiple />,
  },
  {
    title: 'common:TRENDHIMCLUB_FREE_SHIPPING',
    text: 'common:TRENDHIMCLUB_ORDERS_AMOUNT',
    icon: <SvgTruck2 />,
  },
  {
    title: 'common:TRENDHIMCLUB_MEMBER_ONLY_DEALS',
    text: 'common:TRENDHIMCLUB_EXCLUSIVE_NEWS_LAUNCHES',
    icon: <CheckDecagramOutline />,
  },
]

export const ClubInfo: FC<PropsWithChildren<ClubInfoProps>> = ({ children, className, itemClassName }) => {
  const { t } = useTranslation()
  return (
    <div className={clsx(styles.clubInfo, className)}>
      {children}
      {map(ClubInformations, ClubInformation => (
        <div key={`ClubInfo_${ClubInformation.title}`} className={clsx(styles.clubInfoItem, itemClassName)}>
          {ClubInformation.icon}
          <span className={styles.title}>{t(ClubInformation.title)}</span>
          <span className={styles.text}>{t(ClubInformation.text)}</span>
        </div>
      ))}
    </div>
  )
}
